@let memberDataValue = memberData();
@let activeComponentValue = activeComponent();
@let isSelfValue = isSelf();
@let canManageUsersValue = canManageUsers();

<rt-dialog-header class="no-bottom-padding">
  @if (memberDataValue) {
    <tlc-edit-member-header
      [avatarThumbUrl]="memberDataValue.avatarThumbUrl"
      [isOwner]="memberDataValue.hasFullAccess ?? false"
      [email]="memberDataValue.firstName || memberDataValue.lastName ? memberDataValue.email : ''"
      [isDeactivated]="memberDataValue.status === TeamMemberStatus.Deactivated"
      [memberGuid]="memberDataValue.guid"
    />
  }
  <rt-tabs padding-left>
    <rt-tab
      (click)="setActiveTab(isSelfValue ? MemberEditTab.EditProfile : MemberEditTab.Account)"
      [class.active]="
        activeComponentValue === MemberEditTab.Account ||
        activeComponentValue === MemberEditTab.EditProfile
      "
    >
      {{ 'tlc.members.edit_member.tabs.account' | translate }}
    </rt-tab>

    @if (canManageUsersValue) {
      <rt-tab
        (click)="setActiveTab(MemberEditTab.PermissionsAccess)"
        [class.active]="activeComponentValue === MemberEditTab.PermissionsAccess"
      >
        {{ 'tlc.members.edit_member.tabs.permissions_and_access' | translate }}
      </rt-tab>
    }

    @if (groupsFlag()) {
      <rt-tab
        (click)="setActiveTab(MemberEditTab.Groups)"
        [class.active]="activeComponentValue === MemberEditTab.Groups"
      >
        {{ 'tlc.members.edit_member.tabs.groups' | translate }}
      </rt-tab>
    }
    @if (departmentsFlag()) {
      <rt-tab
        (click)="setActiveTab(MemberEditTab.Departments)"
        [class.active]="activeComponentValue === MemberEditTab.Departments"
      >
        {{ 'tlc.members.edit_member.tabs.departments' | translate }}
      </rt-tab>
    }
  </rt-tabs>
</rt-dialog-header>
@if (memberData()) {
  <ng-container
    [rtComponentOutlet]="componentMap.get(activeComponentValue)"
    [rtComponentOutletInputs]="memberInputs"
  />
}
